export const REGEXP_ONLY_LETTERS_AND_NUMBERS =
  /^[A-Za-z0-9\u0410-\u044F\u0401\u0451]+$/;
